<template>
  <b-modal id="proof-of-captured-image-view" size="md" body-class="py-0" hide-footer no-close-on-backdrop
    no-close-on-esc centered @hidden="handleHiddenProofOfImage">
    <template v-if="!!proofOfImage">
      <img id="proof-of-image" :src="proofOfImage.image" class="img-fluid rounded" alt="Proof" />
      <p class="text-center mt-2">
        Uploaded on {{ formatDateTime() }}
      </p>
    </template>
  </b-modal>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { mapState } from "vuex";
import { DateTime } from "luxon";
import _ from "lodash";

export default defineComponent({
  computed: {
    ...mapState("estoreOrders", ["proofOfImage"]),
  },
  setup(__, { root }) {
    const handleHiddenProofOfImage = () => {
      root.$emit("bv::show::modal", "order-details");
      root.$store.state.estoreOrders.proofOfImage = {};
    };
    const formatDateTime = () => {
      const timestamp = _.get(root.$store.state.estoreOrders.proofOfImage, "timestamp", null)
      return timestamp ? DateTime.fromSQL(timestamp).toFormat("LLL d, y H:mm") : ""
    }
    return {
      handleHiddenProofOfImage,
      formatDateTime,
    };
  },
});
</script>

<style lang="scss">
#proof-of-captured-image-view {
  .modal-header {
    .modal-title {
      &::after {
        display: none;
      }
    }
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #proof-of-image {
    max-height: 400px;
  }
}
</style>
